// store/hooks.js
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

// Custom hook to select multiple state slices
export const useAppState = () => {
  const auth = useAppSelector((state) => state.auth);
  const alert = useAppSelector((state) => state.alert);
  const user = useAppSelector((state) => state.user);
  const loading = useAppSelector((state) => state.loading);

  return useMemo(
    () => ({
      auth,
      alert,
      user,
      loading,
    }),
    [auth, alert, user, loading]
  );
};
